<template>
  <div :class="$style.wrapper">
    <div v-if="this.$store.state.admin" :class="$style.add_card" @click="openAddCard">
      <img src="../assets/img/add.svg" alt="" />
    </div>

    <AddCard v-if="showAddCard" @backToCatalog="closeAddCard" />

    <template v-if="this.$store.state.admin">
      <Card
        v-for="object in objects"
        :key="object.id"
        :object="object"
        @click="openEditCard(object)"
      />
    </template>
    <template v-else-if="!this.$store.state.admin">
      <Card
        v-for="object in objects"
        :key="object.id"
        :object="object"
        @click="triggerHapticFeedback"
      />
    </template>

    <EditCard
      v-if="this.$store.state.admin && showEditCard"
      :object="selectedObject"
      @backToCatalog="closeEditCard"
    />
  </div>
</template>

<script>
import Card from '../components/Card.vue';
import AddCard from '../components/AddCard.vue';
import EditCard from '../components/EditCard.vue';

export default {
  components: { Card, AddCard, EditCard },
  props: {
    objects: Array,
  },
  data() {
    return {
      showAddCard: false,
      showEditCard: false,
      selectedObject: null,
    };
  },
  methods: {
    openAddCard() {
      this.triggerHapticFeedback();
      this.showAddCard = true;
    },
    closeAddCard() {
      this.showAddCard = false;
    },
    openEditCard(object) {
      this.triggerHapticFeedback();
      this.selectedObject = object;
      this.showEditCard = true;
    },
    closeEditCard() {
      this.showEditCard = false;
      this.selectedObject = null;
    },

    triggerHapticFeedback() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },
  },
};
</script>

<style lang="scss" module>
.wrapper {
  height: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  max-height: calc(85vh);
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.add_card {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 189px;
  width: 100%;
  border-radius: 16px;
  background-color: $bg-dark;
  grid-column: 1;
  transition: all 0.1s ease;

  img {
    transform: rotate(0);
    transition: all 0.08s ease;
  }

  &:hover {
    background: $background;
    transition: all 0.1s ease;
    img {
      transform: rotate(45deg);
      transition: all 0.08s ease;
    }
  }
}
</style>
